import type { Meta, StoryFn } from '@storybook/react';
import type { AccordionCardProps } from './AccordionCard';

import { AccordionCard } from './AccordionCard';

import { Container } from 'storyComponents/Container';

const codeString = '<AccordionCard title={title} content={content}/>';

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/AccordionCard',
  component: AccordionCard,
  argTypes: {
    expanded: {
      // Hide the expanded prop. Changing the value in Storybook doesn't update the state of the component.
      table: {
        disable: true,
      },
    },
  },
  parameters: {
    inspectComponent: AccordionCard,
    codeString: codeString,
  },
} as Meta<AccordionCardProps>;

const Template: StoryFn<AccordionCardProps> = (args) => (
  <Container size="large">
    <AccordionCard {...args} />
  </Container>
);

export const AccordionCardExample = Template.bind({});
AccordionCardExample.args = {
  title: 'Vakaanbieding 1',
  content: (
    <div>
      <h3 style={{ marginTop: '0' }}>Vakaanmelding: Het Belang van een Goede Start van Je Studiejaar</h3>
      <p>
        Vakaanmelding is een cruciale stap in het studieproces, waarbij studenten zich inschrijven voor de vakken die
        zij tijdens een semester of studiejaar willen volgen. Deze procedure is belangrijk om een gestructureerd en
        succesvol academisch traject te waarborgen. Hieronder bespreken we wat vakaanmelding inhoudt, waarom het
        essentieel is en hoe je je optimaal kunt voorbereiden.
      </p>
      <h3>Wat is vakaanmelding?</h3>
      <p>
        Vakaanmelding is het proces waarbij studenten via een digitaal systeem (zoals Blackboard, Canvas of een
        specifieke universiteitsportal) aangeven welke vakken zij willen volgen. Dit kan variëren van verplichte
        kernvakken tot keuzevakken die aansluiten bij persoonlijke interesses of specialisaties.
      </p>
    </div>
  ),
};
